import './App.css';
import { PageHeader, Button, Drawer, Tooltip, Divider, Layout } from "antd";
import { MenuOutlined, GithubOutlined, TranslationOutlined, HeartOutlined } from "@ant-design/icons";
import {useState, useEffect} from "react";
import SectionCard from "./SectionCard";
import AboutInformation from "./AboutInformation";
import {
    BrowserRouter as Router,
    Link,
    Route,
    Switch
} from "react-router-dom";


function App() {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [fileTree, setFileTree] = useState(null);
  const {Header, Content, Footer} = Layout;
  const [audio, setAudio] = useState(new Audio());

  const handleMenu = () => {
      setDrawerVisible((prev) => !prev);
  }

  const replaceAudio = (audioObject) => {
      setAudio(audioObject);
  }

  const renderCards = () => {
    return (
        <div style={{minHeight: '720px'}}>
           {
            fileTree ? fileTree.sections.map((section) =>
              <SectionCard config={section} audioPanel={audio} updateAudio={replaceAudio}/>
            ) : <div></div>
           }
        </div>
    )
  }

  const toggleDrawer = () => {
      setDrawerVisible(false)
  }

  useEffect(() => {
      console.log("loading data")
      fetch('config.json').then((response) => {
          console.log(response)
          return response.json()
      }).then((response) => {
          console.log(response);
          setFileTree(response);
      }).catch((err) => {
          console.log(err);
      })
  }, [])

  return (
      <Router>
          <Layout>
              <PageHeader
                  backIcon={<MenuOutlined />}
                  title={<Link to="/"><span style={{color: 'black'}}>A-soul按钮</span></Link>}
                  extra={[
                      <Tooltip placement="bottom" title="罕见模式（暂未开放）" key="language">
                          <Button shape="circle" icon={<TranslationOutlined />} />
                      </Tooltip>,
                      <Tooltip placement="bottom" title="开源仓库" key="github">
                          <Button shape="circle"
                                  href="https://github.com/asoulbutton/asoulbutton-src"
                                  target="_blank"
                                  icon={<GithubOutlined />} />
                      </Tooltip>
                  ]}
                  onBack={handleMenu}
              />
              <Content>
                  <Switch>
                      <Route path="/about">
                          <AboutInformation />
                      </Route>
                      <Route path="/">
                          {renderCards()}
                      </Route>
                  </Switch>
              </Content>
              <Footer style={{textAlign: 'center'}}>
                  Made with <HeartOutlined /> by asoul-button team
              </Footer>
              <Drawer
                  title="A-soul按钮"
                  placement="left"
                  visible={drawerVisible}
                  closable={false}
                  onClose={toggleDrawer}
              >
                  <Button type="text" block={true} style={{textAlign: 'left'}} onClick={toggleDrawer}>
                      <Link to="/">主页</Link>
                  </Button>
                  <Button type="text" block={true} style={{textAlign: 'left'}} onClick={toggleDrawer}>
                      <Link to="/about">关于</Link>
                  </Button>
                  <Divider>链接</Divider>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/672346917">向晚大魔王 B站</Button>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/672353429">贝拉Kira B站</Button>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/351609538">珈乐Carol B站</Button>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/672328094">嘉然今天吃什么 B站</Button>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/672342685">乃琳Queen B站</Button>
                  <Button type="link" target="_blank" href="https://space.bilibili.com/703007996">A-SOUL_Official B站</Button>
                  <Button type="link" target="_blank" href="https://www.douban.com/group/a-soul/">豆瓣魂组</Button>
              </Drawer>
          </Layout>
      </Router>

  );
}

export default App;
